import { useEffect, useState } from "react";
import { fetchCaptchaEnabled } from "../utils/captchaConfig";

export function useCaptchaConfig() {
  const [enabled, setEnabled] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetchCaptchaEnabled().then((value) => {
      if (cancelled) return;
      setEnabled(value);
      setLoaded(true);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return {
    enabled: enabled === true,
    required: loaded && enabled === true,
    loaded,
  };
}
